import * as React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

interface FooterProps {}

const Footer = (props: FooterProps) =>
  <section className="order-success-footer">
    <div className="order-success-footer__container container">
      <Link to="/">Express Design &copy; 2017</Link>
      <p className="footer-text">Hotline: 02466.6.02466</p>
    </div>
  </section>;

export default Footer;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/Footer.tsx